import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/thirdParty";

/** Reports SPA route changes to GA4 / Meta once those scripts have loaded. */
const RouteAnalytics = () => {
  const { pathname } = useLocation();
  const first = useRef(true);

  useEffect(() => {
    if (first.current) {
      // The initial page view is sent by gtag config / fbq init.
      first.current = false;
      return;
    }
    trackPageView(pathname);
  }, [pathname]);

  return null;
};

export default RouteAnalytics;
